import { useEffect, useMemo, useState } from "react";
import { v2Contract } from "config";
import { useContractRead } from "wagmi";

const useV2sInWallet = (
  address?: string
): [tokenIds: number[] | undefined, readNftsInWallet: () => void] => {
  const [nftsInWallet, setNftsInWallet] = useState<number[]>();

  const [{ data: nftsInWalletData }, readNftsInWallet] = useContractRead(
    {
      addressOrName: v2Contract.address,
      contractInterface: v2Contract.interface,
    },
    "tokensInWallet",
    {
      args: address,
    }
  );

  useEffect(() => {
    if (nftsInWalletData) {
      setNftsInWallet(nftsInWalletData?.map((bn) => bn.toNumber() as number));
    }
  }, [nftsInWalletData]);

  return useMemo(
    () => [nftsInWallet, readNftsInWallet],
    [nftsInWallet, readNftsInWallet]
  );
};

export default useV2sInWallet;
